import type { NavigationScreenTranslationState } from '@gitbook/app-navigation';
import { Icon } from '@gitbook/spine-icons';
import {
    BreadcrumbItem,
    Breadcrumbs,
    ButtonTab,
    ButtonTabs,
    HeaderBar,
    HeaderBarActions,
    HeaderBarActionsMain,
    HeaderBarBreadcrumbs,
    HeaderBarMain,
    HeaderBarTabs,
} from '@gitbook/spine-react';

import { useNavigation } from '../../navigation';

export function TranslationsScreenLayout(props: {
    screen: NavigationScreenTranslationState;
    headerControls?: React.ReactNode;
    children: React.ReactNode;
}) {
    const { screen, headerControls, children } = props;

    const { navigate } = useNavigation();

    return (
        <>
            <HeaderBar>
                <HeaderBarMain>
                    <HeaderBarBreadcrumbs>
                        <Breadcrumbs>
                            <BreadcrumbItem icon={Icon.AITranslate} label="Translations" />
                        </Breadcrumbs>
                    </HeaderBarBreadcrumbs>
                    <HeaderBarTabs>
                        <ButtonTabs>
                            <ButtonTab
                                label="Overview"
                                active={screen.view === 'overview'}
                                onPress={() => {
                                    navigate({
                                        screen: {
                                            type: 'translations',
                                            organization: screen.organization,
                                            view: 'overview',
                                        },
                                    });
                                }}
                            />
                            <ButtonTab
                                label="Glossary"
                                active={screen.view === 'glossary'}
                                onPress={() => {
                                    navigate({
                                        screen: {
                                            type: 'translations',
                                            organization: screen.organization,
                                            view: 'glossary',
                                        },
                                    });
                                }}
                            />
                        </ButtonTabs>
                    </HeaderBarTabs>
                </HeaderBarMain>
                <HeaderBarActions>
                    <HeaderBarActionsMain>{headerControls}</HeaderBarActionsMain>
                </HeaderBarActions>
            </HeaderBar>

            {children}
        </>
    );
}
